import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Anchor, Group, Stack, Table, Text, Tooltip } from '@mantine/core';
import { IconBrandInstagram, IconUsers } from '@tabler/icons-react';

import { postMetrics, reactionMetrics } from '../../../constants';
import { analyticsTypes } from '../../../types';

import { MetricItem } from './MetricItem';
import { ReactorsModal } from './ReactorsModal';

import { formatDateTimeUTC } from '@/utils/dates';

type TableRowProps = {
  post: analyticsTypes.InstagramReportRow;
};

export const TableRow = ({ post }: TableRowProps) => (
  <Table.Tr>
    <Table.Td>
      <Tooltip label="Click to see post">
        <Anchor href={post.postLink} target="_blank" rel="noopener noreferrer">
          <IconBrandInstagram />
        </Anchor>
      </Tooltip>
    </Table.Td>
    <Table.Td>{formatDateTimeUTC(post.publishDate)}</Table.Td>
    <Table.Td>{post.pageLink}</Table.Td>
    <Table.Td>{post.geo}</Table.Td>
    <Table.Td>{post.topic}</Table.Td>
    <Table.Td>{post.placementCost}</Table.Td>
    <Table.Td>
      <Stack gap={4}>
        {reactionMetrics.map((m) => (
          <MetricItem key={m.key} label={m.label} value={post.reactions[m.key]} />
        ))}
      </Stack>
    </Table.Td>
    <Table.Td>{post.uniqueUsersWithReactionsCount}</Table.Td>
    <Table.Td>
      <Group gap={6} wrap="nowrap">
        <Text>{post.newDialogs}</Text>
        <Tooltip label="View reactor IDs">
          <ActionIcon
            variant="subtle"
            size="sm"
            onClick={() => NiceModal.show(ReactorsModal, { postId: post.postId })}
          >
            <IconUsers size={14} />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Table.Td>
    <Table.Td>
      <Stack gap={4}>
        {postMetrics.map((m) => (
          <MetricItem key={m.key} label={m.label} value={post.metrics[m.key]} />
        ))}
      </Stack>
    </Table.Td>
  </Table.Tr>
);
